import React, { FC, useEffect, useState } from "react";
import { Row, Col, Typography,  Skeleton, Space } from "antd";
import { getDopingList } from "apps/CustomerPanel/Ad/Services";
import { openNotificationWithIcon } from "helpers/OpenNotificationWithIcon";
import { MazakaButton } from "apps/Common/MazakaButton";
import DopingItem from "./DopingItem";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "store/Reducers";
import {
  handleSelectedPackageDoping,
  handleSetDoneSteps,
} from "apps/CustomerPanel/Ad/ClientSideStates";
import { useNavigate, useSearchParams } from "react-router-dom";
import { useGetAdvertDetails } from "apps/RealState/Details/ServerSideStates";
import { Helmet } from "react-helmet-async";

const { Text } = Typography;

interface DopingListItemProps {
  setCurrentStep: any;
  setIsShowDopingLis?: any;
  
  type: string;
}
const DopingListItem: FC<DopingListItemProps> = (props) => {
  const [selectedPlan, setSelectedPlan] = useState<string>("");

  const [data, setData] = useState<any[]>([]);
  const [packageList, setPackageList] = useState<any>([]);
   const [searchParams,setSearchParams] = useSearchParams();
    const advertId = searchParams.get("id");
    const advertDetails = useGetAdvertDetails(advertId || "");
  const [isLoading, setIsLoading] = useState(false);
  const navigate = useNavigate()
  const { selectedPackages, adType } = useSelector(
    (state: RootState) => state.ad
  );
  const dispatch = useDispatch();
  

  const getDopings = async (currentDopingListIds: number[]) => {
    setIsLoading(true);
    try {
      const response: any = await getDopingList();
      if (response?.data) {
        
       
          let packages = response.data.map((item: any) => {
            if (currentDopingListIds.includes(item.id)) {
              return {
                ...item,
                inUser: true,
              };
            }
            return item
          });
         
          if(packages?.length>0)
          {

            setPackageList(packages);
          }
          else{
            if(props.setCurrentStep)
            {

              if (adType === "realState") {
                props.setCurrentStep(8);
              }
              else{
                props.setCurrentStep(9);
              }
            }
            else{
              navigate("/payment")
            }
          }
     
      }
    } catch (error: any) {
      openNotificationWithIcon("default", error?.messge);
      console.log("Somethings wrong during getting packages  ", error);
    } finally {
      setIsLoading(false);
    }
  };
  useEffect(() => {
    managementDopings();
  }, [advertDetails.data]);

  const managementDopings = async () => {
    setIsLoading(true);
    try {
     const currentDopingListIds = 
      advertDetails?.data?.data?.dopingList?.map((item:any)=>item.id)
     
      if (currentDopingListIds?.length>0) {
       
        getDopings(currentDopingListIds);
      }
      else{
        getDopings([]);
      }
    } catch (error: any) {
      openNotificationWithIcon("default", error?.messge);
      console.log("Somethings wrong during getting packages  ", error);
    } finally {
      setIsLoading(false);
    }
  };


 useEffect(() => {
    setSearchParams((prev) => {
      const newParams = new URLSearchParams(prev);
      newParams.set("currentStep", adType === "realState" ? "7" : "8");
      return newParams;
    });
  }, []);


  return (
    <Col xs={24}  className={`!px-0 xl:!px-16 ${props.type==="ad"?"mt-4":""}`} >
      <Helmet>
          <title className="capitalize">{"Doping Seç"}</title>
        </Helmet>
      <Row gutter={[0, 20]}>
        {props.type === "ad" ? (
          <>
            
          </>
        ) : (
          <>
            <Col className="!flex items-center justify-center relative" xs={24}>
              <Text className="!font-bold !text-2xl !text-black">
                Dopingler
              </Text>
            </Col>
          </>
        )}

        <Col xs={24}>
          <Skeleton loading={advertDetails?.isLoading ||advertDetails.isFetching ||isLoading} >
          <Row gutter={[0, 20]}>
            {packageList.map((option: any) => {
              const isSelected = selectedPlan === option.id;
              return (
                <DopingItem
                  isSelected={isSelected}
                  option={option}
                  data={data}
                  setData={setData}
                />
              );
            })}
            
             
              <Col xs={24} className="!flex gap-3">
              {
                packageList?.length>0&&
                <MazakaButton
                  className="!p-4 !bg-[#FFC502] !text-black"
                  onClick={() => {
                    let packages = { ...selectedPackages };
                    packages["dopings"] = data;
                    dispatch(handleSelectedPackageDoping({ data: packages }));
                    if(props.type==="ad")
                    {
                      if (adType === "realState") {
                        props.setCurrentStep(8);
                        dispatch(
                          handleSetDoneSteps({
                            data: [0, 1, 2, 3, 4, 5, 6],
                          })
                        );
                      } else if (adType === "vehicle") {
                        props.setCurrentStep(9);
                        dispatch(
                          handleSetDoneSteps({
                            data: [0, 1, 2, 3, 4, 5, 6, 7],
                          })
                        );
                      }
                    }
                    else{

                      navigate("/payment")
                    }
                  
                  }}
                >
                 {props.type==="profile"?"Plan ve Dopingleri Güncelle":"Kaydet ve Devam et"}
                </MazakaButton>
              }
                {props.type==="ad"&&selectedPackages?.package && (
                  <>
                    <MazakaButton
                      className="!p-4 !bg-black !text-white"
                      htmlType="button"
                      onClick={() => {
                        if (adType === "realState") {
                          props.setCurrentStep(8);
                          dispatch(
                            handleSetDoneSteps({
                              data: [0, 1, 2, 3, 4, 5, 6],
                            })
                          );
                        } else if (adType === "vehicle") {
                         
                          props.setCurrentStep(9);
                          dispatch(
                            handleSetDoneSteps({
                              data: [0, 1, 2, 3, 4, 5, 6, 7],
                            })
                          );
                        }
                      }}
                    >
                     Dopingsiz Devam et 
                    </MazakaButton>
                  </>
                )}
              </Col>
            </Row>
          </Skeleton>
        </Col>
      </Row>
    </Col>
  );
};

export default DopingListItem;
